import { error } from "toastr";
import {
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  GET_DELETED_USERS,
  GET_DELETED_USERS_SUCCESS,
  GET_DELETED_USERS_FAIL,
  GET_ORGANIZATION_DETAILS,
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAIL,
  UPDATE_ROLES,
  UPDATE_ROLES_SUCCESS,
  UPDATE_ROLES_FAIL,
  CREATE_BLUEJAY_TEAM,
  CREATE_BLUEJAY_TEAM_SUCCESS,
  CREATE_BLUEJAY_TEAM_FAIL,
  GET_BLUEJAY_TEAM,
  GET_BLUEJAY_TEAM_SUCCESS,
  GET_BLUEJAY_TEAM_FAIL,
  DELETE_BLUEJAY_TEAM,
  DELETE_BLUEJAY_TEAM_SUCCESS,
  DELETE_BLUEJAY_TEAM_FAIL,
  GET_ORGANIZATION_DETAILS_SUCCESS,
  GET_ORGANIZATION_DETAILS_FAIL,
  GET_SUBSCRIPTION_DETAILS,
  GET_SUBSCRIPTION_DETAILS_SUCCESS,
  GET_SUBSCRIPTION_DETAILS_FAIL,
  INVITE_USER,
  INVITE_USER_FAIL,
  INVITE_USER_SUCCESS,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_BILLING_DETAILS,
  UPDATE_BILLING_DETAILS_SUCCESS,
  UPDATE_BILLING_DETAILS_FAIL,
  UPDATE_BLUEJAY_TEAM,
  UPDATE_BLUEJAY_TEAM_SUCCESS,
  UPDATE_BLUEJAY_TEAM_FAIL,
  DELETE_SERVICE_FROM_TEAM,
  DELETE_SERVICE_FROM_TEAM_SUCCESS,
  DELETE_SERVICE_FROM_TEAM_FAIL,
  GET_UNMAPPED_TEAM_SERVICES,
  GET_UNMAPPED_TEAM_SERVICES_SUCCESS,
  GET_UNMAPPED_TEAM_SERVICES_FAIL,
  MAP_SERVICES_TO_TEAM,
  MAP_SERVICES_TO_TEAM_SUCCESS,
  MAP_SERVICES_TO_TEAM_FAIL,
  NON_TEAM_USERS,
  NON_TEAM_USERS_SUCCESS,
  NON_TEAM_USERS_FAIL,
  ADD_USERS_TO_TEAM,
  ADD_USERS_TO_TEAM_SUCCESS,
  ADD_USERS_TO_TEAM_FAIL,
  REMOVE_USER_FROM_TEAM,
  REMOVE_USER_FROM_TEAM_SUCCESS,
  REMOVE_USER_FROM_TEAM_FAIL,
  GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
  GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL,
  GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS,
  UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
  UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL,
  UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS,
  GET_ORG_AWS_SERVICE_LIST_SUCCESS,
  GET_ORG_AWS_SERVICE_LIST_FAIL,
  GET_ORG_AWS_SERVICE_LIST,
  UPDATE_STATUS_ORG_AWS_SERVICE_FAIL,
  UPDATE_STATUS_ORG_AWS_SERVICE_SUCCESS,
  UPDATE_STATUS_ORG_AWS_SERVICE,
  GET_ALLOWED_DOMAINS_RESTRICTIONS,
  GET_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
  GET_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
  DELETE_ALLOWED_DOMAINS_RESTRICTIONS,
  DELETE_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
  DELETE_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
  POST_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
  POST_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
  POST_ALLOWED_DOMAINS_RESTRICTIONS,
  GET_SSO_ONLY_LOGIN_FAIL,
  GET_SSO_ONLY_LOGIN_SUCCESS,
  GET_SSO_ONLY_LOGIN,
  TOGGLE_SSO_ONLY_LOGIN,
  TOGGLE_SSO_ONLY_LOGIN_SUCCESS,
  TOGGLE_SSO_ONLY_LOGIN_FAIL,
  GET_ALERT_DEPLOYMENT_COUNT,
  GET_ALERT_DEPLOYMENT_COUNT_FAIL,
  GET_ALERT_DEPLOYMENT_COUNT_SUCCESS,
  GET_DAILY_RESOURCE_COUNT,
  GET_DAILY_RESOURCE_COUNT_FAIL,
  GET_DAILY_RESOURCE_COUNT_SUCCESS,
  GET_MONTHLY_RESOURCE_COUNT,
  GET_MONTHLY_RESOURCE_COUNT_FAIL,
  GET_MONTHLY_RESOURCE_COUNT_SUCCESS,
  GET_RESOURCE_SCAN_COUNT,
  GET_RESOURCE_SCAN_COUNT_FAIL,
  GET_RESOURCE_SCAN_COUNT_SUCCESS,
  UPDATE_TWO_FACTOR_ORG_ENABLED,
  UPDATE_TWO_FACTOR_ORG_ENABLED_SUCCESS,
  UPDATE_TWO_FACTOR_ORG_ENABLED_FAIL,
  GET_RESOURCE_MAPPING_CONFIG,
  GET_RESOURCE_MAPPING_CONFIG_FAIL,
  GET_RESOURCE_MAPPING_CONFIG_SUCCESS,
  POST_RESOURCE_MAPPING_CONFIG,
  POST_RESOURCE_MAPPING_CONFIG_FAIL,
  POST_RESOURCE_MAPPING_CONFIG_SUCCESS,
  DELETE_RESOURCE_MAPPING_CONFIG,
  DELETE_RESOURCE_MAPPING_CONFIG_FAIL,
  DELETE_RESOURCE_MAPPING_CONFIG_SUCCESS,
  UPDATE_RESOURCE_MAPPING_CONFIG,
  UPDATE_RESOURCE_MAPPING_CONFIG_FAIL,
  UPDATE_RESOURCE_MAPPING_CONFIG_SUCCESS,
  GET_PAGINATED_USERS,
  GET_PAGINATED_USERS_SUCCESS,
  GET_PAGINATED_USERS_FAIL,
  GET_USERS_COUNT,
  GET_USERS_COUNT_SUCCESS,
  GET_USERS_COUNT_FAIL,
  GET_SUGGESTED_MAPPINGS,
  GET_SUGGESTED_MAPPINGS_SUCCESS,
  GET_SUGGESTED_MAPPINGS_FAIL,
  POST_UPDATE_SUGGESTED_MAPPINGS,
  POST_UPDATE_SUGGESTED_MAPPINGS_SUCCESS,
  POST_UPDATE_SUGGESTED_MAPPINGS_FAIL,
  SET_ORG_MAINTENANCE_WINDOW,
  SET_ORG_MAINTENANCE_WINDOW_SUCCESS, SET_ORG_MAINTENANCE_WINDOW_FAIL,
  GET_CHANGE_EVENT_WEBHOOKS,
  GET_CHANGE_EVENT_WEBHOOKS_SUCCESS,
  GET_CHANGE_EVENT_WEBHOOKS_FAIL,
  GET_CHANGE_EVENTS,
  GET_CHANGE_EVENTS_SUCCESS,
  GET_CHANGE_EVENTS_FAIL,
  GET_CHANGE_EVENT_BY_ID,
  GET_CHANGE_EVENT_BY_ID_SUCCESS,
  GET_CHANGE_EVENT_BY_ID_FAIL,
  CREATE_CHANGE_EVENT_WEBHOOK,
  CREATE_CHANGE_EVENT_WEBHOOK_SUCCESS,
  CREATE_CHANGE_EVENT_WEBHOOK_FAIL, GET_OKTA_SSO_INTEGRATION_SUCCESS, GET_OKTA_SSO_INTEGRATION_FAIL,
  RESET_CREATE_EVENT_WEBHOOK, GET_RECENT_CHANGE_EVENTS_SUCCESS, GET_RECENT_CHANGE_EVENTS_FAIL,
} from "./actionTypes";
import {SET_MAINTENANCE_WINDOW_BY_ID, SET_MAINTENANCE_WINDOW_BY_ID_FAIL, SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS} from "../service/actionTypes";
import {showNotification} from "../../components/Common/notification";

const INIT_STATE = {
  users: [],
  organization: [],
  subscription: [],
  roles: [],
  bluejay_teams: [],
  services: [],
  map_service_to_teams: {},
  delete_bluejay_team: {},
  update_bluejay_team: {},
  delete_service_from_team: {},
  non_team_members: [],
  add_users_to_team: {},
  remove_user_from_team: {},
  org_primary_notif_channels: [],
  update_primary_notif_channels: [],
  org_aws_services:[],
  org_aws_service_status : [],
  allowed_domain_restrictions: [],
  delete_domain_restrictions: [],
  post_allowed_domain_restrictions: [],
  get_sso_only_login: {},
  toggle_sso_only_login: {},
  organization_2fa_enabled: {},
  mapped_services : [],
  suggested_mappings: [],
  deleted_users: [],
  paginatedUsers: [],
  usersCount: [],
  createEventWebhook: null,
  changeEventWebhooks: [],
  changeEvents: [],
  changeEventById: null,
  isUsersLoading: false,
  oktaIntegration: {},
  recentChangeEvents: [],
};

const Organization = (state = INIT_STATE, action) => {
  switch (action.type) {

    case TOGGLE_SSO_ONLY_LOGIN:
      return {
        ...state,
        error: action.payload,
      }

    case TOGGLE_SSO_ONLY_LOGIN_SUCCESS:
      return {
        ...state,
        toggle_sso_only_login: action.payload
      }

    case TOGGLE_SSO_ONLY_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SSO_ONLY_LOGIN:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SSO_ONLY_LOGIN_SUCCESS:
      return {
        ...state,
        get_sso_only_login: action.payload
      }

    case GET_SSO_ONLY_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_ALLOWED_DOMAINS_RESTRICTIONS:
      return {
        ...state,
        error: action.payload,
      }

    case POST_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS:
        return {
            ...state,
            post_allowed_domain_restrictions: action.payload
        }

    case POST_ALLOWED_DOMAINS_RESTRICTIONS_FAIL:
        return {
            ...state,
            error: action.payload,
        }

    case DELETE_ALLOWED_DOMAINS_RESTRICTIONS:
        return {
            ...state,
            error: action.payload,
        }

    case DELETE_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS:
        return {
            ...state,
            delete_domain_restrictions: action.payload
        }

    case DELETE_ALLOWED_DOMAINS_RESTRICTIONS_FAIL:
        return {
            ...state,
            error: action.payload,
        }

    case GET_ALLOWED_DOMAINS_RESTRICTIONS:
        return {
            ...state,
            error: action.payload,
        }

    case GET_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS:
        return {
            ...state,
            allowed_domain_restrictions: action.payload
        }

    case GET_ALLOWED_DOMAINS_RESTRICTIONS_FAIL:
        return {
            ...state,
            error: action.payload,
        }

    case GET_USERS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: Object.assign(state.users, action.payload)
      }

    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DELETED_USERS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DELETED_USERS_SUCCESS:
      return {
        ...state,
        deleted_users: action.payload
      }

    case GET_DELETED_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ALERT_DEPLOYMENT_COUNT:
      return{
        ...state,
        error: action.payload
      }

    case GET_ALERT_DEPLOYMENT_COUNT_FAIL:
      return{
        ...state,
        error: action.payload
      }  
    
    case GET_ALERT_DEPLOYMENT_COUNT_SUCCESS:
      return{
        ...state,
        alertsCount: action.payload
      }    

    case GET_RESOURCE_SCAN_COUNT:
      return{
        ...state,
        error: action.payload
      }
    
    case GET_RESOURCE_SCAN_COUNT_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_RESOURCE_SCAN_COUNT_SUCCESS:
      return{
        ...state,
        resourceScanCount : action.payload
      }
    
    case GET_DAILY_RESOURCE_COUNT:
      return{
        ...state,
        error: action.payload
      }

    case GET_DAILY_RESOURCE_COUNT_FAIL:
      return{
        ...state,
        error: action.payload
      }
    
    case GET_DAILY_RESOURCE_COUNT_SUCCESS:
      return{
        ...state,
        dailyResourceCount: action.payload
      }

    case GET_MONTHLY_RESOURCE_COUNT:
      return{
        ...state,
        error: action.payload
      }

    case GET_MONTHLY_RESOURCE_COUNT_FAIL:
      return{
        ...state,
        error: action.payload
      }
    
    case GET_MONTHLY_RESOURCE_COUNT_SUCCESS:
      return{
        ...state,
        monthlyResourceCount: action.payload
      }

    case GET_ORGANIZATION_DETAILS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ORGANIZATION_DETAILS_SUCCESS:
      return {
        ...state,
        organization: action.payload,
      }

    case GET_ORGANIZATION_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SUBSCRIPTION_DETAILS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        subscription: Object.assign(state.subscription, action.payload)
      }

    case GET_SUBSCRIPTION_DETAILS_FAIL:
      if (action.payload === "Plan has expired") {
        return {
          ...state,
          subscription: {
            ...state.subscription,
            is_expired: true
          },
          error: action.payload,
        }
      }
      return {
        ...state,
        error: action.payload,
      }

    case INVITE_USER:
      return {
        ...state,
        error: action.payload,
      }

    case INVITE_USER_SUCCESS:
      return {
        ...state,
        users: Object.assign(state.users, action.payload)
      }

    case INVITE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_BILLING_DETAILS:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        organization: action.payload,
      }

    case UPDATE_BILLING_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_USER:
      return {
        ...state,
        users: Object.assign(state.users, []),
        error: action.payload,
      }

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: [...action.payload],
      };


    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_USER:
      return {
        ...state,
        users: Object.assign(state.users, []),
        error: action.payload,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: [...action.payload],
      }

    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ROLES:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload
      }

    case GET_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_ROLES:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_ROLES_SUCCESS:
      for (let i = 0; i < state.users.length; i++) {
        if (state.users[i].id === action.payload.user_id) {
          state.users[i].role = action.payload.role
          break;
        }
      }
      return {
        ...state,
        users: state.users
      }

    case UPDATE_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_BLUEJAY_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_BLUEJAY_TEAM_SUCCESS:
      return {
        ...state,
        organization: action.payload,
      }

    case CREATE_BLUEJAY_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BLUEJAY_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BLUEJAY_TEAM_SUCCESS:
      return {
        ...state,
        bluejay_teams: action.payload
      }

    case GET_BLUEJAY_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_BLUEJAY_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_BLUEJAY_TEAM_SUCCESS:
      return {
        ...state,
        delete_bluejay_team: Object.assign(state.delete_bluejay_team, action.payload)
      }

    case DELETE_BLUEJAY_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_BLUEJAY_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_BLUEJAY_TEAM_SUCCESS:
      return {
        ...state,
        update_bluejay_team: Object.assign(state.update_bluejay_team, action.payload)
      }

    case UPDATE_BLUEJAY_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_SERVICE_FROM_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_SERVICE_FROM_TEAM_SUCCESS:
      return {
        ...state,
        delete_service_from_team: Object.assign(state.delete_service_from_team, action.payload)
      }

    case DELETE_SERVICE_FROM_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_UNMAPPED_TEAM_SERVICES:
      return {
        ...state,
        error: action.payload,
      }

    case GET_UNMAPPED_TEAM_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload
      }

    case GET_UNMAPPED_TEAM_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case MAP_SERVICES_TO_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case MAP_SERVICES_TO_TEAM_SUCCESS:
      return {
        ...state,
        map_service_to_teams: Object.assign(state.map_service_to_teams, action.payload)
      }

    case MAP_SERVICES_TO_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case NON_TEAM_USERS:
      return {
        ...state,
        error: action.payload,
      }

    case NON_TEAM_USERS_SUCCESS:
      return {
        ...state,
        non_team_members: action.payload
      }

    case NON_TEAM_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_USERS_TO_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_USERS_TO_TEAM_SUCCESS:
      return {
        ...state,
        add_users_to_team: action.payload
      }

    case ADD_USERS_TO_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case REMOVE_USER_FROM_TEAM:
      return {
        ...state,
        error: action.payload,
      }

    case REMOVE_USER_FROM_TEAM_SUCCESS:
      return {
        ...state,
        remove_user_from_team: action.payload
      }

    case REMOVE_USER_FROM_TEAM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS:
      return {
        ...state,
        org_primary_notif_channels: action.payload
      }

    case GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS:
      state.org_primary_notif_channels = action.payload
      return {
        ...state,
        update_primary_notif_channels: action.payload
      }

    case UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ORG_AWS_SERVICE_LIST:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ORG_AWS_SERVICE_LIST_SUCCESS:
      return {
        ...state,
        org_aws_services: action.payload,
      }

    case GET_ORG_AWS_SERVICE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_STATUS_ORG_AWS_SERVICE_SUCCESS:
      return {
        ...state,
        org_aws_service_status: action.payload
      }
    case UPDATE_STATUS_ORG_AWS_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_STATUS_ORG_AWS_SERVICE:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_TWO_FACTOR_ORG_ENABLED:
      return {
        ...state,
        error: action.payload,
      }
      case UPDATE_TWO_FACTOR_ORG_ENABLED_SUCCESS:
        return {
          ...state,
          organization_2fa_enabled: action.payload.organization_2fa_enabled
        }
      case UPDATE_TWO_FACTOR_ORG_ENABLED_FAIL:
        return {
          ...state,
          error: action.payload,
        }

      case GET_RESOURCE_MAPPING_CONFIG:
        return{
          ...state,
          error: action.payload
        }

      case GET_RESOURCE_MAPPING_CONFIG_FAIL:
        return{
          ...state,
          error: action.payload
        }

      case GET_RESOURCE_MAPPING_CONFIG_SUCCESS:
        return{
          ...state,
          mapped_services: action.payload
        }

      case POST_RESOURCE_MAPPING_CONFIG:
        return{
          ...state,
          error: action.payload
        }

      case POST_RESOURCE_MAPPING_CONFIG_FAIL:
        return{
          ...state,
          error: action.payload
        }

      case POST_RESOURCE_MAPPING_CONFIG_SUCCESS:
        return{
          ...state,
          response_mapped_services: action.payload
        }

      case DELETE_RESOURCE_MAPPING_CONFIG:
        return{
          ...state,
          error: action.payload
        }

      case DELETE_RESOURCE_MAPPING_CONFIG_FAIL:
        return{
          ...state,
          error: action.payload
        }

      case DELETE_RESOURCE_MAPPING_CONFIG_SUCCESS:
        return{
          ...state,
          response: action.payload
        }

      case UPDATE_RESOURCE_MAPPING_CONFIG:
        return{
          ...state,
          error: action.payload
        }

      case UPDATE_RESOURCE_MAPPING_CONFIG_FAIL:
        return{
          ...state,
          error: action.payload
        }

      case UPDATE_RESOURCE_MAPPING_CONFIG_SUCCESS:
        return{
          ...state,
          response: action.payload
        }

      case GET_PAGINATED_USERS:
          return {
              ...state,
              isUsersLoading: true,
          };
      case GET_PAGINATED_USERS_SUCCESS:
          return {
              ...state,
              paginatedUsers: action.payload,
              isUsersLoading: false,
          };
      case GET_PAGINATED_USERS_FAIL:
          return {
              ...state,
              error: action.payload,
              isUsersLoading: false,
          };
      case GET_USERS_COUNT:
          return {
              ...state,
              isUsersLoading: true,
          };
      case GET_USERS_COUNT_SUCCESS:
          return {
              ...state,
              usersCount: action.payload,
              isUsersLoading: false,
          };
      case GET_USERS_COUNT_FAIL:
          return {
              ...state,
              error: action.payload,
              isUsersLoading: false,
          };
      case GET_SUGGESTED_MAPPINGS:
          return {
            ...state,
            error: action.payload,
          };
      case GET_SUGGESTED_MAPPINGS_SUCCESS:
          return {
              ...state,
              suggested_mappings: action.payload
          };
      case GET_SUGGESTED_MAPPINGS_FAIL:
          return {
            ...state,
            error: action.payload
          };
      case POST_UPDATE_SUGGESTED_MAPPINGS:
        return {
            ...state,
            error: action.payload
        };
    case POST_UPDATE_SUGGESTED_MAPPINGS_SUCCESS:
      return{
        ...state,
        error: action.payload
      }
    case POST_UPDATE_SUGGESTED_MAPPINGS_FAIL:
      return{
        ...state,
        error: action.payload
      }
    case SET_ORG_MAINTENANCE_WINDOW:
      return {
        ...state,
        error: action.payload
      };

    case SET_ORG_MAINTENANCE_WINDOW_SUCCESS:
      showNotification("success", action.payload.message);
      let organization = state.organization;
      organization.maintenance_window_end = action.payload.maintenance_window_end;
      return {
        ...state,
        organization: organization
      };

    case SET_ORG_MAINTENANCE_WINDOW_FAIL:
      return {
        ...state,
        error: action.payload
      };

      case GET_CHANGE_EVENT_WEBHOOKS:
        return {
          ...state,
          error: action.payload,
        };
      case GET_CHANGE_EVENT_WEBHOOKS_SUCCESS:
        return {
          ...state,
          changeEventWebhooks: action.payload
        };
      case GET_CHANGE_EVENT_WEBHOOKS_FAIL:
        return {
          ...state,
          error: action.payload,
        };

      case GET_CHANGE_EVENTS:
        return {
          ...state,
          error: action.payload,
        };

      case GET_CHANGE_EVENTS_SUCCESS:
        return {
          ...state,
          changeEvents: action.payload
        };

      case GET_CHANGE_EVENTS_FAIL:
        return {
          ...state,
          error: action.payload,
        };
      
      case GET_CHANGE_EVENT_BY_ID:
        return {
          ...state,
          error: action.payload,
        };
      
      case GET_CHANGE_EVENT_BY_ID_SUCCESS:
        return {
          ...state,
          changeEventById: action.payload
        };

      case GET_CHANGE_EVENT_BY_ID_FAIL:
        return {
          ...state,
          error: action.payload,
        };

      case CREATE_CHANGE_EVENT_WEBHOOK:
        return {
          ...state,
          error: action.payload,
        };

      case CREATE_CHANGE_EVENT_WEBHOOK_SUCCESS:
        return {
          ...state,
          createEventWebhook: action.payload
        };

      case CREATE_CHANGE_EVENT_WEBHOOK_FAIL:
        return {
          ...state,
          error: action.payload,
        };
      case 'RESET_CREATE_EVENT_WEBHOOK':
        return {
          ...state,
          createEventWebhook: {}
        };

     case GET_OKTA_SSO_INTEGRATION_SUCCESS:
        return {
          ...state,
          oktaIntegration: action.payload
        };

    case GET_OKTA_SSO_INTEGRATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_RECENT_CHANGE_EVENTS_SUCCESS:
      return {
        ...state,
        recentChangeEvents: action.payload
      }
    case GET_RECENT_CHANGE_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Organization;